import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Moment from "react-moment";
import { API_URL } from '../../config/apiEndpoints';
import 'moment/locale/ro';
import { Link } from 'react-router-dom';
import Favorite from '../favorite/favorite.component';
import Parser from 'html-react-parser';
import { slugify } from '../../helpers/general.helper';


class ArticleItem extends Component {

    render() {
        return (
            <Fragment>
                <div className="row article-item-container">
                    <div className="col-2 image-container">
                        <img src={API_URL + this.props.article.article_image} alt={'Article'} />
                    </div>
                    <div className="col-9">
                        <div className="article-title">{this.props.article.article_title}</div>
                        <div className="article-date">
                            <Moment format="DD MMMM YYYY" locale="ro" unix>
                                {this.props.article.article_created}
                            </Moment></div>
                        <div className="article-description">{Parser(this.props.article.article_summary)}
                            <Link to={`/stire/${this.props.article.article_id}/${slugify(this.props.article.article_title)}`} className="article-link">
                                &nbsp;Citeşte tot >>
                            </Link>
                        </div>
                    </div>
                    <div className="col-1 icons-container">
                        <Favorite
                            favorite={this.props.article.favorite}
                            component="list"
                            type={this.props.component}
                            id={this.props.article.article_uuid}
                        />
                    </div>
                </div>
                <div className="col-12 end-line marginTop"></div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(ArticleItem);





// WEBPACK FOOTER //
// ./src/SHARED/components/articles/articlesitem.component.js